export default "__VITE_ASSET__BS_HaGlt__"